'use strict';

angular.module('membership')
  .controller('PartnershipsCtrl', [
    '$scope', 'partnershipsViewModel',
    function ($scope, viewModel) {
      $scope.model = new viewModel($scope.company);
    }
  ]);
